import React from 'react';
import { Link } from 'react-router-dom';
import { Award, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <>
      <style>{`
        .footer {
          background: #0F1118;
          padding: 70px 0 30px;
          color: #FFFFFF;
        }
        
        .footer-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }
        
        .footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 48px;
          margin-bottom: 48px;
        }
        
        .footer-h3 {
          font-family: 'Bebas Neue', sans-serif;
          font-size: 24px;
          color: #FFC300;
          margin-bottom: 20px;
          letter-spacing: 1px;
        }
        
        .footer-text {
          font-family: 'Work Sans', sans-serif;
          font-size: 14px;
          line-height: 1.7;
          color: #CCCCCC;
        }
        
        .footer-badge {
          display: flex;
          align-items: center;
          color: #FFC300;
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 8px;
        }
        
        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }
        
        .footer-link {
          font-family: 'Work Sans', sans-serif;
          font-size: 14px;
          color: #CCCCCC;
          text-decoration: none;
          transition: color 0.3s ease;
          font-weight: 600;
        }
        
        .footer-link:hover {
          color: #FFC300;
        }
        
        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 32px;
          text-align: center;
          font-family: 'Work Sans', sans-serif;
          font-size: 14px;
          color: #999;
        }
        
        .footer-bottom p {
          margin-bottom: 8px;
        }
      `}</style>
      
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div>
              <h3 className="footer-h3">DRIVEN2WIN</h3>
              <p className="footer-text">
                America's #1 automotive event marketing company. Serving car, motorcycle, 
                golf cart, ATV, and RV dealers nationwide since 2001.
              </p>
              <div style={{marginTop: '16px'}}>
                <div className="footer-badge">
                  <Award size={20} style={{marginRight: '8px'}} />
                  <span>23+ Years in Business</span>
                </div>
                <div className="footer-badge">
                  <MapPin size={20} style={{marginRight: '8px'}} />
                  <span>Nationwide Coverage</span>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="footer-h3">OUR SERVICES</h3>
              <div className="footer-links">
                <Link to="/services/offsite-events" className="footer-link">Offsite Sales Events</Link>
                <Link to="/services/tent-setups" className="footer-link">Tent Setups & Permitting</Link>
                <Link to="/services/direct-mail" className="footer-link">Direct Mail Marketing</Link>
                <Link to="/services/facebook-events" className="footer-link">Facebook & Instragram Events</Link>
                <Link to="/services/ai-bdc" className="footer-link">AI BDC Agents</Link>
              </div>
            </div>
            
            <div>
              <h3 className="footer-h3">COMPANY</h3>
              <div className="footer-links">
                <Link to="/about" className="footer-link">About Us</Link>
                <Link to="/event-results" className="footer-link">Event Results</Link>
                <Link to="/testimonials" className="footer-link">Testimonials</Link>
                <Link to="/faq" className="footer-link">FAQ</Link>
                <Link to="/contact#contact-form" className="footer-link">Contact Us</Link>
                <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                <Link to="/terms" className="footer-link">Terms of Service</Link>
              </div>
            </div>
            
            <div>
              <h3 className="footer-h3">CONTACT</h3>
              <div className="footer-text">
                <div style={{ marginBottom: '12px', fontWeight: '700', color: '#FFC300' }}>
                  <Phone size={16} style={{display: 'inline-block', marginRight: '8px'}} />
                  <a href="tel:904-638-7200" style={{color: '#FFC300', textDecoration: 'none', fontSize: '20px'}}>904-638-7200</a>
                </div>
                <div style={{ marginBottom: '8px' }}>
                  <a href="mailto:info@driven2win.com" className="footer-link">info@driven2win.com</a>
                </div>
                <div style={{ marginBottom: '8px', fontSize: '14px' }}>5285 Shad Road, Suite 1619</div>
                <div style={{ fontSize: '14px' }}>Jacksonville, FL 32257</div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2026 Driven2WIN. All Rights Reserved.</p>
            <p><strong>Serving Dealerships Nationwide Since 2001</strong> | America's #1 Automotive Event Company</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
